import { useEffect, useState } from "react"
import Loader from "../../../components/Loader"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleCheck } from "@fortawesome/pro-duotone-svg-icons"
import { useNavigate } from "react-router-dom"
import Header from "../../../components/Header"
import { faLeftLong } from "@fortawesome/sharp-solid-svg-icons"
import Button from "@mui/material/Button"
import { useTranslation } from "react-i18next"

type LoginStatesProps = {
    loading: boolean
    error?: boolean
}
const LoginStates = (props: LoginStatesProps) => {
    const navigate = useNavigate()

    const { t: translate } = useTranslation()

    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        if (!props?.error) {
            setIsLoading(true)
            const interval = setInterval(() => {
                setTimeout(() => {
                    setIsLoading(false)
                    setTimeout(() => {
                        navigate("/commissioning-form/ticketing-details")
                    }, 4000);
                }, 3000);
            }, 1000)
            return () => {
                clearInterval(interval)
            }
        } else {
            setIsError(true)
            const interval = setInterval(() => {
                setTimeout(() => {
                    setIsLoading(false)
                }, 3000);
            }, 1000)
            return () => {
                clearInterval(interval)
            }
        }
    }, [props.loading, props?.error])

    const renderLoginStates = () => {
        if (isError) {
            return isLoading ?
                <Loader text={translate("verifyingText")} /> : <Box>
                    <Header heading={translate("wrongCode")} subHeading={translate("wrongCodeSubText")} />
                    <Button
                        sx={{
                            marginTop: "60px",
                            minWidth: "165px"
                        }}
                        size="small"
                        variant="outlined"
                        onClick={() => window.location.reload()}>
                        <FontAwesomeIcon icon={faLeftLong} style={{ color: "#000", height: "8px", width: "12px", marginRight: "8px" }} />
                        <Typography fontSize={"18px"} fontWeight={500}>
                            {translate("tryAgain")}
                        </Typography>
                    </Button>
                </Box>
        } else {
            return isLoading ?
                <Loader text={translate("verifyingText")} /> :
                <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center", height: "calc(100% - 104px)" }}>
                    <FontAwesomeIcon icon={faCircleCheck} style={{ "--fa-primary-color": "#34c759", "--fa-secondary-color": "#34c759", height: "24px", width: "24px" }} />
                    <Typography fontSize={"18px"} >
                        {translate("verificationSuccessful")}
                    </Typography>
                </Box>
        }
    }
    return (
        <Box textAlign={"center"} height={"calc(100vh - 152px)"} alignContent={"center"}>
            {renderLoginStates()}
        </Box>
    )
}
export default LoginStates